export default "<kt-splash-screen *ngIf=\"loader\"></kt-splash-screen>\n<kt-loading-screen ></kt-loading-screen>\n<router-outlet></router-outlet>\n"